import Icon from "@/icons";

export default function Replying({ replyTo, setReplyTo }: any) {
    return (
        <div className="zjustify-between flex items-center space-x-2 bg-brand-back px-2 rounded-t-lg w-full">
            <div className="flex items-center space-x-1 bg-brand-back p-2 rounded-t-lg w-full">
                <span className="font-light text-gray-300">
                    Replying to
                </span>
                <span className="font-semibold text-gray-300">
                    {replyTo.createdBy.username}
                </span>
                <span className="font-light text-gray-300">
                    &gt; {replyTo?.content?.length > 50 ? `${replyTo?.content?.slice(0, 50)}...` : replyTo?.content}
                </span>
            </div>
            <div className="flex items-center space-x-2 bg-brand-back p-2 rounded-t-lg">
                <button className="flex items-center justify-center px-2 h-8 w-8 rounded-full bg-brand-green transition-all duration-300" onClick={() => setReplyTo(null)}>
                    <Icon name="delete" size="20" color="white" />
                </button>
            </div>
        </div>
    )
}